import { render, staticRenderFns } from "./AuctionFormPopup.vue?vue&type=template&id=61bfbeb4"
import script from "./AuctionFormPopup.vue?vue&type=script&lang=js"
export * from "./AuctionFormPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports